import {Box, Button, Card, CircularProgress, Grid, Typography} from "@mui/material";
import {Spacer} from "../../../common";
import CardContent from "@mui/material/CardContent";
import I18n from "i18n-js";
import LimitBar from "./LimitBar";
import React, {useEffect, useState} from "react";
import {useNavigate} from "react-router-dom";
import {getLimitCounts, LimitCounts} from "./BillingDetailsApi";
import OrderList from "./order-list/OrderList";
import {AccountBundle, getAccountBundle} from "../../identity/identityAPI";
import moment from "moment";


export default function BillingDetails() {
  const navigate = useNavigate();
  const [limitCounts, setLimitCounts] = useState<LimitCounts|undefined>(undefined);
  const [accountBundle, setAccountBundle] = useState<AccountBundle|null>(null);

  useEffect(() => {
    updateAccountBundle();
    updateLimitCounts();

  }, []);

  if (!accountBundle) {
    return (
      <Box sx={{display: 'flex', justifyContent: 'center'}}>
        <CircularProgress />
      </Box>
    );
  }

  async function updateLimitCounts() {
    const response = await getLimitCounts();

    setLimitCounts(response.data.data);
  }

  async function updateAccountBundle() {
    const response = await getAccountBundle();

    if (response.success && response.data.data) {
      const data = response.data.data as AccountBundle;

      if (data === null) {
        navigate("/plans", {replace: true});
        return;
      }

      setAccountBundle(data);
    }
  }


  return (
    <Box>
      <Typography variant="h1">
        {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.billingDetails")}
      </Typography>
      <Spacer h={1}/>
      <Grid container spacing={2}>
        <Grid item md={9} sm={12} xs={12}>
          <Grid container spacing={2}>
            <Grid item md={6} sm={6} xs={12}>
              <Card sx={{minWidth: 100}}>
                <CardContent>
                  <Typography variant="body1" gutterBottom>
                    {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.currentPlan")}
                  </Typography>

                  <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1, my: 1}}>
                    <Typography variant="h4">
                      ${accountBundle.price}
                    </Typography>
                    <Typography variant="h4" color="text.secondary">
                      {I18n.t("MyAccount.pages.billingAndPlans.bundlesPeriod." + accountBundle.type.toLowerCase())}
                    </Typography>
                  </Box>

                  <Typography variant="h5" sx={{mb: 3}}>
                    {accountBundle.name}
                  </Typography>

                  <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                    <Button variant="contained" onClick={() => {
                      navigate("/plans")
                    }}>
                      {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.changePlan")}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
            <Grid item md={6} sm={6} xs={12}>
              <Card sx={{minWidth: 100}}>
                <CardContent>
                  <Typography variant="body1" gutterBottom>
                    {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.nextPayment")}
                  </Typography>

                  <Box sx={{display: 'flex', alignItems: 'baseline', gap: 1, my: 1}}>
                    <Typography variant="h4">
                      ${accountBundle.next_billing_price}
                    </Typography>
                    <Typography variant="h4" color="text.secondary">
                      {I18n.t("MyAccount.pages.billingAndPlans.bundlesPeriod." + accountBundle.next_billing_type.toLowerCase())}
                    </Typography>
                  </Box>

                  <Typography variant="h5" sx={{mb: 3}}>
                    On {moment(accountBundle.next_billing_date).format('MMMM D YYYY')}
                  </Typography>

                  <Box sx={{display: 'flex', justifyContent: 'flex-start'}}>
                    <Button variant="contained" onClick={() => {
                      navigate("/manage-payments")
                    }}>
                      {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.managePayments")}
                    </Button>
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>

          <Spacer h={2}/>
          <Typography variant="h2">
            {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.paymentHistory")}
          </Typography>
          <Spacer h={2}/>

          <OrderList />
        </Grid>
        <Grid item md={3} sm={12} xs={12}>
          <Card>
            <CardContent>
              {limitCounts !== undefined
              ? <Box>
                  <LimitBar value={limitCounts.users} max={accountBundle.user_limit} name={"users"}/>
                  <Spacer h={1}/>

                  <LimitBar value={limitCounts.waivers} max={accountBundle.waiver_limit} name={"waivers"}/>
                  <Spacer h={1}/>

                  <LimitBar value={limitCounts.storage} max={accountBundle.storage_limit} name={"storage"}/>
                  <Spacer h={1}/>

                  <LimitBar value={limitCounts.submits} max={accountBundle.submit_limit} name={"submits"}/>
                  <Spacer h={1}/>

                  <LimitBar value={limitCounts.locations} max={accountBundle.location_limit} name={"locations"}/>
                </Box>
              : <Box sx={{display: 'flex', justifyContent: 'center'}}>
                  <CircularProgress />
                </Box>}

              <Spacer h={2}/>

              <Box sx={{display: "flex", justifyContent: "center"}}>
                <Button variant="contained" onClick={() => {
                  navigate("/plans")
                }}>
                  {I18n.t("MyAccount.pages.billingAndPlans.billingDetails.upgradePackage")}
                </Button>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
}